import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import RCTContainer from "components/QualityAssurance/Sections/Calc/RCTContainer";
import HiddenFromQAMessage from "components/PhoenixFormsV4/HiddenFromQAMessage.tsx";
import { userHasRight } from "selectors/rights";
import { AI_FORM_VERIFICATION_RESULTS_VIEW } from "typeConstants/rights";

const Calc = (props) => {
    const { controlNumber, caseRCT, aiVerificationResults, canViewAIFormResults } = props;

    if (Object.keys(caseRCT).length) {
        return (
            <Grid size={12} className="width-unset flex-child flex-parent flex-column">
                {!!(aiVerificationResults?.formCanBeHiddenFromQa && canViewAIFormResults) && <HiddenFromQAMessage />}
                <RCTContainer caseRCT={caseRCT} controlNumber={controlNumber} />
            </Grid>
        );
    } else return null;
};

Calc.propTypes = {
    // passed props
    controlNumber: PropTypes.number.isRequired,
    aiVerificationResults: PropTypes.object,

    // redux props
    caseRCT: PropTypes.object,
    canViewAIFormResults: PropTypes.bool,
};

const mapStateToProps = state => {
    return {
        caseRCT: state.qualityAssurance.caseRCT,
        canViewAIFormResults: userHasRight(AI_FORM_VERIFICATION_RESULTS_VIEW)(state),
    };
};

export default connect(mapStateToProps)(Calc);